import { State, Country } from "country-state-city";

export const STATE_OPTIONS = (country?: string) => [
  { value: "all", label: "All States" },
  ...State.getStatesOfCountry(country || "NG").map((state) => ({
    value: state.isoCode,
    label: state.name,
  })),
];

export const COUNTRY_OPTIONS = [
  { value: "all", label: "All Countries" },
  ...Country.getAllCountries().map((country) => ({
    value: country.isoCode,
    label: country.name,
  })),
];

export const HOME_PAGE = "/home";
export const SIGNIN_PAGE = "/signin";
export const LANDING_PAGE = "/";

export const ROUTES = {
  HOME: "/home",
  SIGNIN: "/signin",
  LANDING: "/",
  LISTINGS: "/home/listings",
  VERIFY: "/verify?type=individual",
  ORDERS: "/home/orders",
  PROFILE: "/home/profile",
  SETTINGS: "/home/settings",
  WALLET: "/home/wallet",
};
